export const SET_INSURANCE_TOKEN_EXPIRES_DATE = 'SET_INSURANCE_TOKEN_EXPIRES_DATE';

export const setInsuranceTokenExpirationDate = ({ oAuthTokenExpiresAt }) => ({
  type: SET_INSURANCE_TOKEN_EXPIRES_DATE,
  payload: {
    oAuthTokenExpiresAt
  }
});
